import React from 'react';
import ContentSection from '../ContentSection';
import './styles.css';

const LessonTeachersSection = (props) => (
  <ContentSection className="teachers-section">
    <h1>We will teach you to play!</h1>
    <p>
      Our teaching schedule runs from mid-morning until 8 pm Monday through Friday and from 10 am - 5 pm on Saturday. Our studio rate is $20 per half-hour time slot.
    </p>
    <div className="call-to-action">
      Please call us at <a href="tel:765-474-2942">(765)474-2942</a> {/*or <a onClick={props.onMessageLinkClick}>click here</a>*/} with questions or to reserve your time slot.
    </div>
    <p>
      Stop dreaming and start playing at McGuire Music!
    </p>
  </ContentSection>
);

export default LessonTeachersSection;



// WEBPACK FOOTER //
// ./src/components/LessonTeachersSection/index.js